const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as const;

function padTwoDigits(value: number) {
  return String(value).padStart(2, '0');
}

function formatTwelveHourTime(hour24: number, minute: number, second: number) {
  const period = hour24 >= 12 ? 'PM' : 'AM';
  const normalizedHour = hour24 % 12 === 0 ? 12 : hour24 % 12;
  return `${normalizedHour}:${padTwoDigits(minute)}:${padTwoDigits(second)} ${period}`;
}

function formatParts(year: number, month: number, day: number, hour24: number, minute: number, second: number) {
  const monthLabel = MONTH_LABELS[month - 1];
  if (!monthLabel) {
    return null;
  }

  return `${monthLabel} ${padTwoDigits(day)}, ${year}, ${formatTwelveHourTime(hour24, minute, second)}`;
}

function normalizeDateTimeForParsing(value: string) {
  const dateTimeWithoutZone = /^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)$/;
  const match = value.match(dateTimeWithoutZone);

  return match ? `${match[1]}T${match[2]}Z` : value;
}

export function formatDisplayDateTime(value: string | null | undefined, fallback = 'N/A') {
  if (value == null) {
    return fallback;
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return fallback;
  }

  const dateOnlyMatch = trimmedValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (dateOnlyMatch) {
    const year = Number(dateOnlyMatch[1]);
    const month = Number(dateOnlyMatch[2]);
    const day = Number(dateOnlyMatch[3]);
    return formatParts(year, month, day, 0, 0, 0) ?? fallback;
  }

  const parsedValue = new Date(normalizeDateTimeForParsing(trimmedValue));
  if (Number.isNaN(parsedValue.getTime())) {
    return fallback;
  }

  return formatParts(
    parsedValue.getFullYear(),
    parsedValue.getMonth() + 1,
    parsedValue.getDate(),
    parsedValue.getHours(),
    parsedValue.getMinutes(),
    parsedValue.getSeconds(),
  ) ?? fallback;
}